// extracted by mini-css-extract-plugin
export default {"tooltip":"tr-z","sharingV2":"ur-z","sharingIconsV2":"vr-z","links":"wr-z","link":"xr-z","facebookV2":"yr-z","twitterV2":"zr-z","pinterestV2":"Ar-z"};